import React, { Component } from "react";
import Slider from '@material-ui/lab/Slider';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
// import './viz.css';

import './robert.css';


import saved_state from './data/savedstate.json';


import { Annotation,Note } from 'react-annotation'
//Force
// import nodes from './data/force_directed_nodes_all.csv';
// import edges from './data/force_directed_edges_all.csv';



// import netClustering from './netClustering.js';
// import fileDownload from 'js-file-download';


import {parse} from 'flatted/esm';




import * as d3 from 'd3';

const label = ( title, content) => {
    return {title,content}
}


const labels = {}

const plabel = (n,i) => {
    labels[i] = n;
}

plabel("Python",28)
plabel('C++',5)
plabel('Windows',6)
plabel('OS / Scripting',26)
plabel('Version Control / SSH',25)
plabel('CSS',10)
// plabel('Java Testing',13)
plabel('Web App Protocols',20)
plabel('Javascript / Web', 8)
plabel('OOP',0)
plabel('Node.js',24)
plabel('Angular / Mobile',22)
plabel('Android',19)
plabel('PHP',11)
plabel('Java',17)
plabel('C / Programming',1)
plabel('Events / Go', 3)
plabel('C#', 15)
plabel('Math / Algorithms', 27)

console.log(labels,"LABELS")

class Explorer extends Component {
    constructor(props){
        super(props);
        this.state = {
            selected: [],
          
            links: props.links,
            oglinks: props.links,
            ognodes: props.nodes,
            nodes: props.nodes,
            data:[],
            edges: [],
            nodemap: {},
            forceConstant: 1,
            collide: true,
            edgeThresh: 25,
            nodeFilterThresh: 50000,
            forceXY: .4,
            forceManyBody: -150,
            distance: 25,
            strength:.2,
            groupAmount: 10,
            mx: 0,
            focus: null,
            my:0,
            developerMode: false,

        }


    }
    _onMouseMove = (e) => {
        this.setState({ mx: e.pageX, my: e.pageY });
      }

    calculateHulls = (nodes) => {
        var delanuyPoints = []
        var hulls = {};
        nodes.forEach(d => {
            delanuyPoints.push([d.x,d.y])
            if(hulls[d.cluster] === undefined){
                hulls[d.cluster] = [];
            }
            hulls[d.cluster].push({x:d.x, y:d.y });
        })
        var voronoi = d3.voronoi().extent([[-400, -400], [400 + 1, 400 + 1]]);
        var polygons = voronoi.polygons(delanuyPoints);
        var arrHulls = [];
        for (var key in hulls){
            if(!hulls.hasOwnProperty(key)) continue;
            var arr = hulls[key];
            var h = d3.polygonHull(arr)
            //Might need to change this, something is wrong with hulls color
            // if(h !== null)
            arrHulls.push({hull: h, cluster: key });       
        }
        

        return {arrHulls, polygons}

    }

//     loadStatic = () => {
//         var colors = d3.schemeSet3.reverse()

//         colors.forEach(d => d.brighter(20))

//         this.color = d3.scaleOrdinal(colors)
//         this.size = d3.scaleSqrt()
//             .domain([30000, 7874521])
//             .range([3, 30]);


//         var {arrHulls,polygons} = this.calculateHulls(nodes_static)

//         this.setState({hulls: arrHulls});
//         this.setState({voronoi_polygons: polygons})
//         this.setState({data:nodes_static})
//         this.setState({links:edges_static})

//   }  

  componentDidMount() {

    this.size = d3.scaleSqrt()
    .domain([30000, 7874521])
    .range([3, 30]);

    // this.loadNodes()
    // .then(this.loadEdges)
    // .then(this.initializeForce);

    this.readInState()


    this.div = d3.select("#explorer")
        .select("#titletooltup")
        .attr("class", "tooltip")
        .style("display", "none");

    this.clickdiv = d3.select("#contenttooltip")
        .attr("class", "nodetooltip")
        .style("display", "none");

  }

  readInState = () => {

    // console.log(saved_state)
    var state = parse(((saved_state)))

    this.initColorScale()
    this.setLinkScales(state.links)

    this.setState(state)

    this.startForce(state)


  }

  

  componentWillUnmount() {
    if(this.force)
        this.force.stop();
  }

  
  startForce = ({data,links}) => {

    var comp = this;

     this.forceCollide = d3.forceCollide()
        // .radius((d) => {return (d.radius + 1 )})
        .radius((d) => {return this.scaledDown(d.radius + 3 )})
        .iterations(1); 
    

    this.force =  d3.forceSimulation()
        .nodes(data)
        .force("center",d3.forceCenter(0,0))
        .force("collide", this.state.collide ?  this.forceCollide : null)
        .force("cluster", this.forceCluster)
        .force("gravity", d3.forceManyBody().strength(this.state.forceManyBody))
        .force("link", d3.forceLink(links).id(function(d) { return d.id; })
        .distance(function(d){return comp.distance(d.weight)})
        .strength(function(d){return comp.strength(d.weight)})
        .iterations(1))
        .force("x", d3.forceX().strength(this.state.forceXY))
        .force("y", d3.forceY().strength(this.state.forceXY))


      this.force.stop()



  }

  initializeForce = () => {


    // var data = this.state.data;
    // var links = this.state.links;
    // var clusters = this.state.clusters;

    // console.log(clusters,"Clusters");


    var comp = this;

        // netClustering.cluster(data, links, "cluster", "weight"); 
    
        // var cluster_count = {};
        // data.forEach(n => {
        //   if(!cluster_count[n.cluster]) cluster_count[n.cluster] = 1;
        //   else cluster_count[n.cluster] += 1

        //   if (!clusters[n.cluster] || (n.radius > clusters[n.cluster].radius)){
        //       clusters[n.cluster] = n
        //   };
        // })


        // for( var i =0; i< 100; i++) comp.force.tick(100);

        var {links,data} = this.state


        var {arrHulls,polygons} = this.calculateHulls(data)
        comp.setState({data,links,hulls:arrHulls,voronoi_polygons: polygons})

        var tick = 0;
        this.force.on("tick", () => {

            if(tick === 1){
                var {arrHulls,polygons} = this.calculateHulls(data)
                comp.setState({data,links,hulls:arrHulls,voronoi_polygons: polygons})
                tick = 0

            }
            tick +=1
        
        });



    

  }

    forceCluster = (alpha) => {
        var {clusters,forceConstant, data} = this.state
        for (var i = 0, n = data.length, node, cluster, k = alpha * 1; i < n; ++i) {
            node = data[i];
            cluster = clusters[node.cluster];
            node.vx -= ((node.x - cluster.x) * k)/forceConstant;
            node.vy -= ((node.y - cluster.y) * k)/forceConstant;    
            }
    }   

  linkFilter = (d) => {
    var map = this.state.nodemap;
    var source,target;
    if (typeof(d.source) === 'object'){
        source = d.source.id;
        target = d.target.id;
    } else {
        source = d.source;
        target = d.target
    }

    
    return (map[source] !== undefined
            && map[target] !== undefined
            && d.weight > this.state.edgeThresh)
    

  }

  linkFilterBefore = (d) => {
    var map = this.state.nodemap;

    return (map[d.source] !== undefined
        && map[d.target] !== undefined
          && d.weight > this.state.edgeThresh)
  

  }

  resetColors = () => {
    d3.selectAll(".node").classed("fill-black",false);
    d3.selectAll(".link").classed("stroke-grey",false);
  }

  updateForce = (type) => {

    // this.resetColors();

    this.initializeForce()

    var newLinks;
    if(type ==='thresh'){
        newLinks = this.state.oglinks.filter(this.linkFilter);
    } else if(type === 'strength') {
       this.strength.range([0,this.state.strength]);
    } else if(type === 'distance') {
        this.distance.range([this.state.distance, 0]);
    } else if(type === 'forceConstant') {
        this.force.force("cluster", this.forceCluster)
    } else if(type === 'collide') {
        if(!this.state.collide)
            this.force.force("collide",this.forceCollide)
        else
            this.force.force("collide", null)
    }else if( type=== 'forceXY'){
        this.force.force("x", d3.forceX().strength(this.state.forceXY))
        .force("y", d3.forceY().strength(this.state.forceXY))

    }else if(type === 'forceManyBody'){
        this.force.force('gravity', d3.forceManyBody().strength(this.state.forceManyBody))
    }


    this.force.restart();
    this.force.alpha(.5);


    
    var {links} = this.state
    var comp = this;

    this.force.force("link", 
    d3.forceLink(links).id(function(d) { return d.id; })
    .distance(function(d){return comp.distance(d.weight)})
    .strength(function(d){return comp.strength(d.weight)})
    .iterations(100))



  }

  initColorScale = () => {
    var colors = ["#1f77b4", "#ff7f0e", "#2ca02c", "#d62728", "#9467bd", "#8c564b", "#e377c2", "#bcbd22", "#17becf"].reverse()
    colors = [...colors.reverse(), ...colors.map(d => d3.hsl(d).brighter(.8).toString()).reverse(),  ...colors.map(d => d3.hsl(d).brighter(1.3).toString())]


    console.log(colors)
    this.color = d3.scaleOrdinal(colors)
    .domain([0,this.state.groupAmount]);
  }

//   loadNodes = () => {

// // current group labels are for nodeThresh = 500000

//     var comp = this;
//     return new Promise(function (resolve, reject){
       
//         comp.initColorScale()

//         d3.csv(nodes).then(function(olddata) {
//         var size = d3.scaleSqrt()
//         .domain([30000, 7874521])
//         .range([5, 30]);
//             var data = []
//             var clusters = [];
//             var map = {}

//             var node_count = {}
//             olddata.forEach((d,i) => {
//                 var n = {}
//                 n.group = +d.Group;
//                 n.fill = comp.color(+d.Group);
//                 n.radius = size(+d.Occurances);
//                 n.id = +d.Id
//                 n.label = d.Label
//                 n.links = [];
        
//                 if(n.group < comp.state.groupAmount && n.radius > size(comp.state.nodeFilterThresh)){
//                     data.push(n);

//                     map[n.id] = n;
//                     if (!clusters[n.group] || (n.radius > clusters[n.group].radius)) clusters[n.group] = n;
//                 }
//             })  
//             resolve({data,nodemap:map, clusters})
//             // comp.setState({data:data,nodemap:map, clusters: clusters});
//         });
//     })

//   }

  setLinkScales = (links) => {

    var comp = this;
    var domain =  d3.extent(links, d=> +d.weight)
    comp.distance = d3.scaleSqrt().domain(domain).range([comp.state.distance, 0]);
    comp.strength = d3.scaleLinear().domain(domain).range([0,comp.state.strength]);  
    

  }

//   loadEdges = ({data,nodemap, clusters}) => {


//     var size = d3.scaleSqrt()
//     .domain([10, 200])
//     .range([2, 2]);

//     var opacity = d3.scaleLinear()
//     .domain([10, 200])
//     .range([0, .5]);

//     var comp = this;
//     return new Promise(function (resolve, reject){ 

//          d3.csv(edges).then(function(new_links){
//             var links = [];
//             var map = nodemap;

  
//             this.setLinkScales(new_links)


//             // new_links = new_links.filter(d => +d.Weight > comp.state.edgeThresh)

//              new_links.forEach(d => {  
//                  var n = {}  
//                  n.source = +d.Source;
//                  n.target = +d.Target;
//                  n.weight = +d.Weight;
//                  n.strokeWidth = size(n.weight);
//                  n.opacity = opacity(n.weight);
//                  if(map[n.source])
//                      map[n.source].links.push(n);
//                  if(map[n.target])
//                      map[n.target].links.push(n);
                 
//                  if(map[n.target] && map[n.source])
//                  links.push(n);
//              })
//              console.log(links,"links")
//              console.log(map);
//              resolve({data,links,nodemap,clusters})
//              comp.setState({oglinks: links,nodemap,clusters})
//          });
//     } )
   
    
//   }


  handleDelete = item => () => {
    this.setState(state => {
      const selected = [...state.selected];
      selected.splice(selected.indexOf(item), 1);

      this.props.setMustTags(selected);
      return { selected };
    });
  };

  handleSliderThresh = (event, value) => {
    this.setState({ edgeThresh:value });
    this.updateForce('thresh')
  };

  handleSliderForceXY = (event, value) => {
    this.setState({ forceXY: value });
    this.updateForce('forceXY')
  };

  handleSliderConstant = (event, value) => {
    this.setState({ forceConstant:value });
    this.updateForce('forceConstant')
  };

  handleSliderDistance = (event, value) => {
    this.setState({ distance:value });
    this.updateForce('distance')
  };
  handleCollide = (event, value) => {
    this.setState({ collide: value });
    this.updateForce('collide')
  };

  handleSliderStrength = (event, value) => {
    this.setState({ strength:value });
    this.updateForce('strength')
  };

  handleSliderforceManyBody = (event,value) => {
    this.setState({forceManyBody: value})
    this.updateForce('forceManyBody')
  }


  mouseEnter = (node) => {
    d3.select(".i" +node.id).classed("active",true);

    this.div
        .style("display", "inline")
 
    }

    mouseMove = (node) => {
       this.div.text(node.label)
            .style("left", this.state.mx + "px")
            .style("top",this.state.my - 30 + "px");
        }

    mouseExit = (node) => {
        d3.select(".i" +node.id).classed("active",false);
        this.div.style("display", "none");
        if(this.state.focus === null)
            this.setState({codeExample: null})
    }

    activate = (node) => {
        var linktext = [];
        d3.selectAll(".node").classed("fill-black",true);
 
        // Performance issues
        // d3.selectAll(".link").classed("stroke-grey",true);

        var comp = this;

        d3.selectAll(".n" +node.cluster).classed("fill-black",false);
        d3.selectAll(".n" +node.cluster).classed("stroke-grey",false);

        d3.select(".annotation"+node.cluster).transition().style("opacity",'1')

        d3.selectAll(".n" +node.cluster).each(function(d){
            var me = d3.select(this)
            linktext.push({label: me.attr("datalabel"), count: comp.size.invert(me.attr('r')) });
        })
       
        // console.log(node)


        this.clickdiv
        .html('<h1 class="title">Tag: ' + node.label  + '<br/>Occurrences: ' + d3.format(".2s")(Math.round(this.size.invert(node.radius)))+'</h1><h4>Tag cluster (most to least common): </h4>\
        <p class="body-text">' + linktext.map(d => d.label).join(", ") + '</p>')
        .style("display", "inline");

        // if(this.state.focus !== null){
            // autoComplete(node.id).then(d => {
            //     var info = JSON.parse(d);
            //     this.setState({codeExample: info.example})
            // });   
            d3.select(".i" + this.state.focus).classed("selected",false);
        // }
        d3.select(".i" + node.id).classed("selected",true).raise();
        this.setState({focus: node.id});
    }

    deactivate = (node) => {
        d3.selectAll(".node").classed("fill-black",false);
       // d3.selectAll(".link").classed("stroke-grey",false);
        d3.select(".annotation"+node.cluster).transition().style("opacity",'0')

        this.clickdiv.style("display","none");
        d3.select(".i" + this.state.focus).classed("selected",false);
        this.setState({focus: null,codeExample:null})

    }



//     downloadState = () => {
//         fileDownload(JSON.stringify(stringify(this.state)),'savedstate.json')
//     }

//     downloadNodes = () => {

//     var nodes = JSON.stringify(this.state.data.map( (d)=>{
//         return {id:d.id,
//                 radius: d.radius,
//                 x: d.x, y: d.y,
//                 cluster: d.cluster,
//                 label: d.label
//                 }
//     }))

//     fileDownload(nodes, 'nodes.json');
// }

// downloadEdges = () => {
//     var edges = JSON.stringify(this.state.links.map( (link)=>{
//         return {source: {x: link.source.x, y: link.source.y, group: link.source.group, id: link.source.id,  label: link.source.label},
//                 target: {x: link.target.x, y: link.target.y, group: link.target.group, id: link.target.id, label: link.target.label},
//                 strokeWidth: link.strokeWidth
//                 }
//     }))

//     fileDownload(edges, 'edges.json');

// }

developerMode = () => {
    this.setState((state) => ({developerMode: !state.developerMode} ))
}
  

  render() {
    var lines = d3.line()
    .x(function(d) { return d.x; })
    .y(function(d) { return d.y; });



    this.scaledDown = d3.scaleLinear()
                    .domain([3,30])
                    .range([5,15])


    const transformString = "translate(350,320) scale(.8)"

    return (
      <div id="explorer" 
    //   onMouseMove={this._onMouseMove}
      >

            <h3 className="header-title"> Stack Overflow Relationship Network</h3>
            <h6 className="header-subtitle">  Each node is a Stack Overflow tag. The clusters were formed using this <a className="good-link" href="http://scaledinnovation.com/analytics/communities/communities.html">community detection</a> algorithm. <br/> 
Hover for tag occurrences and node cluster. Tags are sized by occurrences. Darker links reflect a higher co-use in posts.</h6>
 
       

            <a href="#" className="dev-mode good-link" onClick={this.developerMode}>{!this.state.developerMode ? "Development Mode" : "Production Mode (scroll down)"}</a>
            <div className="flexbox-container">
           <svg ref={node => this.node = node}
            width={700} height={700}>
            <g>
  
                <g transform={transformString} >
                {this.state.hulls && this.state.hulls.map((hull,i) => (
                    hull.hull !== null && hull.hull.length > 6 &&
                    (<g key={i} style={{pointerEvents:'none'}} >    
                
                    
                    <g className={'annotation' + hull.cluster}
                        id={'annotation' + hull.cluster}
                        style={{opacity:'0'}}>   
                    <Annotation   
                        style={{textAlign:"left"}}                
                        x={hull.hull[hull.hull.length/2].x}
                        y={hull.hull[hull.hull.length/2].y}
                        nx={-400}
                        ny={-360}
                        title={labels[hull.cluster] ? labels[hull.cluster] : ""}
                    >
                    
                 
                        <Note titleSize={'2em'} titleColor={this.color(i)} orientation="leftRight" align="left" lineType="horizontal" wrap={460} padding={10} />
                    </Annotation>
                    </g>  

                    <path key={i} className={hull.cluster + " clusterhull"} stroke={this.color(i)} d={lines(hull.hull) + "Z"}/>
                    </g>)
                ))}




           


                </g>
                <g transform={transformString}>
                {this.state.links && this.state.links.map((link, index) =>(
                <line
                    className={"link"}
                    x1={link.source.x}
                    y1={link.source.y}
                    x2={link.target.x}
                    y2={link.target.y}
                    strokeOpacity={link.opacity}
                    key={`line-${index}`}
                    stroke={this.color(link.source.group)} 
                    strokeWidth={link.strokeWidth} />
                ))}  
                {this.state.data && this.state.data.map((node, index) =>(
                    
                    (<g 
                        onMouseEnter={() => {this.activate(node)}} 
                        // onClick={() => this.nodeClick(node)}
                        onMouseOut={() => this.deactivate(node)}
                        datalabel={node.label}
                        key={index}>
                                
                    <circle 
                        className={'node ' + 'n'+node.cluster + ' i'+ node.id + ' vindex' + index}
                        // r={(node.radius)} 
                        r={this.scaledDown(node.radius)} 
                        cx={node.x} cy={node.y} 
                        // fill={node.fill} 
                        fill={this.state.cluster_count[node.cluster] > 4 ? this.color(node.cluster) : 'whitesmoke'} 
                        style={{pointerEvents:'none'}}
                        datalabel={node.label}
                    />
                    <path className={"v" + index} style={{opacity:0}} d={this.state.voronoi_polygons[index] ? "M" + this.state.voronoi_polygons[index].join("L") + "Z" :null}/> 

                    </g>)
                ))}


                 {this.state.hulls && this.state.hulls.map((hull,i) => (
                    hull.hull !== null && hull.hull.length > 6 && (<use key={i} style={{pointerEvents: 'none'}} xlinkHref={"#annotation" + hull.cluster}/> )  )) }

                </g>
            </g> 

            

            </svg>

            <div id="contenttooltip">

            </div>

            {/* End of flexBox container */}
            </div>
            {this.state.developerMode && <div className="controllers">
            <Typography id="strength">Maximum Link strength: {this.state.strength}</Typography>
            <Slider
            value={this.state.strength}
            min={0}
            aria-labelledby="strength"
            max={5}
            step={.1}
            onChange={this.handleSliderStrength}
            />
            <Typography id="distance">Maximum Link Distance: {this.state.distance}</Typography>
            <Slider
            value={this.state.distance}
            min={0}
            aria-labelledby="distance"
            max={300}
            step={10}
            onChange={this.handleSliderDistance}
            />
            <Typography id="forceConstant">Force Cluster (attractive force of clusters): {this.state.forceConstant}</Typography>
            <Slider
            value={this.state.forceConstant}
            min={1}
            aria-labelledby="forceConstant"
            max={25}
            step={1}
            onChange={this.handleSliderConstant}
            />
            <Typography id="forceXY">XY Constant Force: {this.state.forceXY}</Typography>
            <Slider
            value={this.state.forceXY}
            min={0}
            aria-labelledby="forceXY"
            max={5}
            step={.1}
            onChange={this.handleSliderForceXY}
            />
            <Typography id="forceManyBody">Many Body Constant: {this.state.forceManyBody}</Typography>
            <Slider
            value={this.state.forceManyBody}
            min={-150}
            aria-labelledby="forceManyBody"
            max={150}
            step={10}
            onChange={this.handleSliderforceManyBody}
            />
            <Typography id="collide">Collide: </Typography>
            <Checkbox
            checked={this.state.collide}
            aria-labelledby="collide"
            onChange={this.handleCollide}
            />

            </div>}
      </div>
    );
  }
}


export default Explorer;


